import React, { useState, useEffect, /*useRef*/} from 'react';
import { Link, useLocation } from 'react-router-dom';

import DataTable from 'react-data-table-component';
import "react-data-table-component-extensions/dist/index.css";

import Calendar from '@toast-ui/react-calendar';
import 'tui-calendar/dist/tui-calendar.css';

// If you use the default popups, use this.
import 'tui-date-picker/dist/tui-date-picker.css';
import 'tui-time-picker/dist/tui-time-picker.css';

import ProgressBar from '../Assec/ProgressBar'

import Swal from 'sweetalert2'

import uniqid from 'uniqid';

import { language } from '../WEBContent/Language';

import { 
    set_language,
    reqGET, 
    reqPOST, 
} from '../../Utils';
import { getTokenInfo } from './../../UseToken';
import UseSidebar from './../../UseSidebar';

import Hosts from '../../Hosts'

export default function View(props) {

    const [lang, set_lang] = useState('pt');
    //const [, set_lang_id] = useState('1');
    const [refresh, setRefresh] = useState(0);

    const [n_testimony, set_n_testimony] = useState(0)
    const [n_cursos, set_n_cursos] = useState(0)
    const [n_cursos_para_incricao, set_n_cursos_para_incricao] = useState(0)
    const [n_inscricoes, set_n_inscricoes] = useState(0)
    const [n_trainees, set_n_trainees] = useState(0)
    const [n_trainers, set_n_trainers] = useState(0)
    
    const [/*a_cursos_inscrito*/, set_a_cursos_inscrito] = useState([])
    const [/*a_cursos*/, set_a_cursos] = useState([])
    const [a_cursos_c, set_a_cursos_c] = useState([])
    const [a_cursos_d, set_a_cursos_d] = useState([])
    
    const [/*aFormationsId*/, set_aFormationsId] = useState([])

    const [schedueles, setSchedueles] = useState([]);
    const [calendars, setCalendars] = useState([]);
    const [selectedView, /*setSelectedView*/] = useState('month');
    const [calendarTitle, setcalendarTitle] = useState('');

    const [percentagem, setPercentagem] = useState([])

    const [isloading, setLoading] = useState(true);

    const change_lang = (l) => {
        set_language(l)
        set_lang(l)
        window.location.reload()

        //console.log('language', localStorage.getItem('lang'))
        //console.log('localstorage', localStorage)
    }

    //var today = new Date()

    /*var calendar_views = [
        {
            name: language[lang].calendar_month,
            value: 'month'
        }, 
        {
            name: language[lang].calendar_week,
            value: 'week'
        },
        {
            name: language[lang].calendar_day,
            value: 'day'
        }
    ]*/

    /*const getDate = (type, start, value, operator) => {
        start = new Date(start);
        type = type.charAt(0).toUpperCase() + type.slice(1);
    
        if (operator === '+') {
            start[`set${type}`](start[`get${type}`]() + value);
        } 
        else {
            start[`set${type}`](start[`get${type}`]() - value);
        }
    
        return start;
    };*/

    /*const aux_schedueles = [
        {
            id: '1',
            calendarId: '1',
            title: 'TOAST UI Calendar Study',
            category: 'time',
            dueDateClass: '',
            start: today.toISOString(),
            end: getDate('hours', today, 3, '+').toISOString()
        },
        {
            id: '2',
            calendarId: '0',
            title: 'Practice',
            category: 'time',
            dueDateClass: '',
            start: getDate('date', today, 1, '+').toISOString(),
            end: getDate('date', today, 1, '+').toISOString(),
            isReadOnly: true
        },
        {
            id: '3',
            calendarId: '0',
            title: 'FE Workshop',
            category: 'allday',
            dueDateClass: '',
            start: getDate('date', today, 2, '-').toISOString(),
            end: getDate('date', today, 1, '-').toISOString(),
            isReadOnly: true
        },
        {
            id: '4',
            calendarId: '0',
            title: 'Report',
            category: 'milestone',
            dueDateClass: '',
            start: today.toISOString(),
            end: getDate('hours', today, 1, '+').toISOString()
        }
    ]*/

    const get_events = async (ids, start, end) => {
        await reqGET(`${Hosts.SIMCore_API}/calendar/event/range/${getTokenInfo().companycode}/${start}/${end}`)
            .then(res => { 
                //setData(res.data); setLoading(false) 
                let aux_schedueles = []
                //console.log('EVENTO SEM DATA', res.data)
                res.data.forEach((v) => {

                    //console.log('v', v)

                    if(v.info.start !== '' && v.info.end !== '') {
                        if(ids.includes(v.info['id_formation'])) {
                            aux_schedueles.push({
                                id: v.id,
                                companycode: v.info.companycode,
                                calendarId: v.info.calendarId,
                                title: v.info.title,
                                body: v.info.body,
                                category: v.info.category,
                                dueDateClass: v.info.dueDateClass,
                                start: v.info.start,
                                end: v.info.end,
                                isAllDay: v.info.isAllDay,
                                location: v.info.location,
                                state: v.info.state,
                                raw: v.info.raw,
                                isReadOnly: v.info.isReadOnly,
                                id_formation: v.info['id_formation']
                            })
                        }
                    }
                })

                //console.log('EVENTOS COM DATA', aux_schedueles)

                setSchedueles(aux_schedueles)

                //console.log('AUX SHEDULES: ', aux_schedueles)
                setLoading(false)
                
            })
            .catch(() => 404)
    }

    const get_calendars = async () => {
        await reqGET(`${Hosts.SIMCore_API}/calendar/category/${getTokenInfo().companycode}`)
            .then(res => { 
                //setData(res.data); setLoading(false) 
                let aux_calendar = []
                
                res.data.forEach((v) => {
                    aux_calendar.push({
                        id: v.id,
                        name: v.info.name,
                        bgColor: v.info.bgColor,
                        borderColor: v.info.borderColor,
                        status: v.info.status
                    })
                })

                setCalendars(aux_calendar)
            })
            .catch(() => 404)
    }


    const { pathname } = useLocation();
    const [, set_sidebar] = useState([])
    const [/*permissions*/, set_permissions] = useState({})

    let get_permissions = (e, sidebar) => {
        let handleSingleCheck = (e, sidebar) => {
            const name = e;

            let ver_submenu = (node) => {
                if (node.submenu.length !== 0) {

                    node.submenu.forEach(subitem => {

                        if (subitem.path === name) {
                            set_permissions({ edit: subitem.edit, gest: subitem.gest, view: true, remove: subitem.remove })
                        }
                        else {
                            ver_submenu(subitem)
                        }

                    })
                }
            }

            sidebar.forEach(node => {
                if(node.path === name && 0) {
                    set_permissions({ edit: node.edit, gest: node.gest, view: true, remove: node.remove })
                } else
                    ver_submenu(node)
            })
        }

        handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        //console.log(getTokenInfo().profile)
        //set_lang('pt')
        //set_lang_id('1')

        if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            change_lang('pt')
        }
        else {
            set_lang(localStorage.getItem('lang'))
        }

        if(getTokenInfo().profile === 'Webuser') {

            reqGET(`${Hosts.SIMCore_API}/web/content/type/${Hosts.companycode}/testimony`)
                .then(res => { 
                    set_n_testimony(res.data.length)
                })
                .catch(erro => console.log('Erro 1', erro))

        }

        if(getTokenInfo().profile === 'Gestor de formações' || getTokenInfo().profile === 'Administrador') {

            reqGET(`${Hosts.SIMCore_API}/entities/list/${Hosts.companycode}/trainee_user`)
            .then(res => { 

                set_n_trainees(res.data.length)
            })
            .catch(erro => console.log('Erro 1', erro))

            reqGET(`${Hosts.SIMCore_API}/entities/list/${Hosts.companycode}/trainer_user`)
            .then(res => { 

                set_n_trainers(res.data.length)
            })
            .catch(erro => console.log('Erro 1', erro))

        }

        reqGET(`${Hosts.SIMCore_API}/formation/course/${Hosts.companycode}`)
            .then(res => { 

                let i = 0
                //let cursos = a_cursos
                //let cursos_inscrito = a_cursos_inscrito
                let cursos_para_inscricao = []
                let cursos_inscrito = []
                let cursos_d = []
                let cursos_c = []
                let ids = []
                res.data.forEach(element => {

                    if(getTokenInfo().profile === 'trainer_user') {

                        //console.log('aqui')
                        element.content[0].modules.forEach((el_m) => {
                            //console.log('aqui2', el_m)
                            if(el_m.trainer !== undefined) {
                                //console.log('aqui3')
                                if(el_m.trainer.id === getTokenInfo().id) {
                                    i++
                                    cursos_inscrito.push(element)
        
                                    ids.push(element.id)

                                    let date_today = new Date().toJSON().split('T')[0];
    
                                    let date_end = element.info.date.end.split('T')[0];

                                    //let el_aux = JSON.parse(JSON.stringify(el_m))
                                    //el_aux.info.name = el_aux.info.name + ': ' + el_m.name
                                    
                                    el_m.id_module = el_m.id
                                    el_m.id_formation = element.id
                                    el_m.name_formation = element.info.name
                                    el_m.id = element.id + '' + el_m.id

                                    if(date_end === '' || date_today < date_end) {
                                        cursos_d.push(el_m)
                                    }
                                    else {
                                        cursos_c.push(el_m)
                                    }
                                }
                            }
                        })
                    }
                    else if(getTokenInfo().profile === 'trainee_user') {
                        if(element.content[0].trainees !== undefined) {
                            let aux = element.content[0].trainees.filter(el => el.trainee_id === getTokenInfo().id)

                            if(aux.length > 0) {
                                i++
                                cursos_inscrito.push(element)
    
                                ids.push(element.id)

                                let date_today = new Date().toJSON().split('T')[0];

                                let date_end = element.info.date.end.split('T')[0];
    
                                if(date_end === '' || date_today < date_end) {
                                    cursos_d.push(element)
                                }
                                else {
                                    cursos_c.push(element)
                                }

                            }
                        }
                    }
                    else if(getTokenInfo().profile === 'Gestor de formações' || getTokenInfo().profile === 'Administrador') {

                        //i++
                        //cursos_inscrito.push(element)

                        ids.push(element.id)

                        let date_today = new Date().toJSON().split('T')[0];

                        let date_end = element.info.date.end.split('T')[0];

                        let date_registration_deadline = element.info.date.registration_deadline.split('T')[0];

                        //console.log(element)

                        if(element.info.date.publication !== '' && date_registration_deadline !== '' && date_today <= date_registration_deadline) {
                            cursos_para_inscricao.push(element)
                        }

                        if(date_end === '' || date_today < date_end) {
                            cursos_d.push(element)
                        }
                        else {
                            cursos_c.push(element)
                        }

                        
                    }

                });
                set_n_inscricoes(i)
                set_n_cursos(res.data.length)
                set_a_cursos_inscrito(cursos_inscrito)
                set_n_cursos_para_incricao(cursos_para_inscricao.length)
                set_a_cursos_c(cursos_c)
                set_a_cursos_d(cursos_d)
                set_a_cursos(res.data)
                set_aFormationsId(ids)

                //console.log(cursos_inscrito)

                get_events(ids, start, end)
            })
            .catch(erro => console.log('Erro 2', erro))


        let d1 = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
        let d2 = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)

        let start = d1.getFullYear() + '-' + ((d1.getMonth() + 1) + '').padStart(2, '0') + '-' + (d1.getDate() + '').padStart(2, '0')
        let end = d2.getFullYear() + '-' + ((d2.getMonth() + 1) + '').padStart(2, '0') + '-' + (d2.getDate() + '').padStart(2, '0')

        //get_events(start, end)
        //get_events()

        get_calendars()

        //setSchedueles(aux_schedueles)
        //setCalendars(aux_calendars)
        setcalendarTitle(new Date().toLocaleString(language[localStorage.getItem('lang')].calendar_language, { month: 'long', year: 'numeric' }))

        const coursesStatus = async () => {
            if('trainee_user' === getTokenInfo().profile) {
                return reqGET(`${Hosts.SIMCore_API}/formation/course/search/trainee/${getTokenInfo().companycode}/${getTokenInfo().id}`)
                    
                    .then(res => {
                        //let array_aux = []
                        let y = percentagem
                        //let percentagem_aux = 0
                        //let sum = 0
                        res.data.forEach(el => {
                            if(el.content[0]['modules'] !== undefined && el.content[0]['modules'] !== null) {

                                let sum = 0
                                //let x = el.content[0]['trainees'].filter(el_2 => el_2.trainee_id === getTokenInfo().id)
    
                                //console.log('array trainees: ', x)
                                //if(x.length > 0){
                                    //array_aux.push(el)
                                    el.content[0].modules.forEach(k => {
    
                                        //console.log(console.log('array modules: ', k))
                                        if(k.trainees !== undefined && k.trainees !== null) {

                                            let trainee_aux = k['trainees'].filter(el_2 => el_2.trainee_id === getTokenInfo().id)
                                            trainee_aux.forEach(v => {
                                                //console.log('array module trainees: ', v)
                                                //console.log('avaliação trainee: ', v.trainee_module_evaluation)

                                                if(v.trainee_module_evaluation !== undefined && v.trainee_module_evaluation !== ''){
                                                    sum ++;
                                                    //console.log('SOMA 1', sum)
                                                }
                                            })
                                        }
                                    })
    
                                    //console.log(el.id)
                                    //console.log('soma final: ', sum)
                                    //console.log('modules length: ', el.content[0].modules.length)
                                    y[el.id] = (sum * 100) / el.content[0].modules.length
                                    setPercentagem(y)
    
                                    //console.log('PERCENTAGEM', percentagem)
                                    
    
                                //}
                            }
                        })     
                        setLoading(false)
                    })
                    .catch(() => 404
                        //  TODO: ENVIAR PÁGINA 404
                        //alert(error)); 
                    )
    
            }
        }

        coursesStatus()

        UseSidebar().getSidebar(getTokenInfo().profile)
            .then(v => {
                get_permissions(pathname, v)
                set_sidebar(v)
                //setLoading(false)
            }); 

    }, [props, pathname, percentagem, refresh]);

    const myTheme = {
        // Theme object to extends default dark theme.
    };
      
    const myTemplate = {
        milestone(schedule) {
            return `<span style="color:#fff;background-color: ${schedule.bgColor};">${schedule.title}</span>`;
        },
        milestoneTitle() {
            return 'Milestone';
        },
        task: function(schedule) {
            return '#' + schedule.title;
        },
        taskTitle: function() {
            return '<span className="tui-full-calendar-left-content">Tarefa</span>';
        },
        allday(schedule) {
            return `${schedule.title}<i className="fa fa-refresh"></i>`;
        },
        alldayTitle() {
            return language[lang].calendar_allday;
        },
        popupIsAllDay: function() {
            return language[lang].calendar_allday;
        },
        popupStateFree: function() {
            return language[lang].calendar_free;
        },
        popupStateBusy: function() {
            return language[lang].calendar_busy;
        },
        titlePlaceholder: function() {
            return language[lang].calendar_title_placeholder;
        },
        locationPlaceholder: function() {
            return language[lang].calendar_location_placeholder;
        },
        startDatePlaceholder: function() {
            return language[lang].calendar_start_placeholder;
        },
        endDatePlaceholder: function() {
            return language[lang].calendar_end_placeholder;
        },
        popupSave: function() {
            return language[lang].calendar_save;
        },
        popupUpdate: function() {
            return language[lang].calendar_update;
        },
        // popupDetailDate: function(isAllDay, start, end) {
        //     var isSameDate = moment(start).isSame(end);
        //     var endFormat = (isSameDate ? '' : 'YYYY.MM.DD ') + 'hh:mm a';

        //     if (isAllDay) {
        //         return moment(start).format('YYYY.MM.DD') + (isSameDate ? '' : ' - ' + moment(end).format('YYYY.MM.DD'));
        //     }

        //     return (moment(start).format('YYYY.MM.DD hh:mm a') + ' - ' + moment(end).format(endFormat));
        // },
        popupEdit: function() {
            return language[lang].calendar_edit;
        },
        popupDelete: function() {
            return language[lang].calendar_delete;
        }
    }

    /* const calendarOptions = {
        sort of option properties.
    }; */

    const calendarRef = React.createRef();
    /*const handleClickButton = (type) => {
        const calendarInstance = calendarRef.current.getInstance();

        if(type === 'today') {
            calendarInstance.today();

            let d1 = new Date(calendarInstance.getDate().getFullYear(), calendarInstance.getDate().getMonth(), 1)
            let d2 = new Date(calendarInstance.getDate().getFullYear(), calendarInstance.getDate().getMonth() + 1, 0)

            let start = d1.getFullYear() + '-' + ((d1.getMonth() + 1) + '').padStart(2, '0') + '-' + (d1.getDate() + '').padStart(2, '0')
            let end = d2.getFullYear() + '-' + ((d2.getMonth() + 1) + '').padStart(2, '0') + '-' + (d2.getDate() + '').padStart(2, '0')

            get_events(start, end)
        }
        if(type === 'prev') {
            calendarInstance.prev();

            let d1 = new Date(calendarInstance.getDate().getFullYear(), calendarInstance.getDate().getMonth(), 1)
            let d2 = new Date(calendarInstance.getDate().getFullYear(), calendarInstance.getDate().getMonth() + 1, 0)

            let start = d1.getFullYear() + '-' + ((d1.getMonth() + 1) + '').padStart(2, '0') + '-' + (d1.getDate() + '').padStart(2, '0')
            let end = d2.getFullYear() + '-' + ((d2.getMonth() + 1) + '').padStart(2, '0') + '-' + (d2.getDate() + '').padStart(2, '0')

            get_events(start, end)
        }
        if(type === 'next') {
            calendarInstance.next();

            let d1 = new Date(calendarInstance.getDate().getFullYear(), calendarInstance.getDate().getMonth(), 1)
            let d2 = new Date(calendarInstance.getDate().getFullYear(), calendarInstance.getDate().getMonth() + 1, 0)

            let start = d1.getFullYear() + '-' + ((d1.getMonth() + 1) + '').padStart(2, '0') + '-' + (d1.getDate() + '').padStart(2, '0')
            let end = d2.getFullYear() + '-' + ((d2.getMonth() + 1) + '').padStart(2, '0') + '-' + (d2.getDate() + '').padStart(2, '0')

            get_events(start, end)
        }

        if(type === 'day') {
            calendarInstance.changeView(type, true);
            setSelectedView(type)
        }
        if(type === 'week') {
            calendarInstance.changeView(type, true);
            setSelectedView(type)
        }
        if(type === 'month') {
            calendarInstance.changeView(type, true);
            setSelectedView(type)
        }

        if(calendarInstance.getViewName() === 'day') {
            setcalendarTitle(calendarInstance.getDate()._date.toLocaleString(language[lang].calendar_language, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }))
        }
        if(calendarInstance.getViewName() === 'week') {
            setcalendarTitle(calendarInstance.getDateRangeStart()._date.toLocaleString(language[lang].calendar_language, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }) + ' ~ ' + calendarInstance.getDateRangeEnd()._date.toLocaleString(language[lang].calendar_language, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })) 
        }
        if(calendarInstance.getViewName() === 'month') {
            setcalendarTitle(calendarInstance.getDate()._date.toLocaleString(language[lang].calendar_language, { month: 'long', year: 'numeric' }))
        }

        //calendarInstance.toggleSchedules('0', true, true)

        //console.log(calendarInstance.getViewName())
        // console.log(calendarInstance.getDate())
        // console.log(calendarInstance.getDate()._date)
        // console.log(calendarInstance.getDate()._date.toLocaleString('default', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }))
    };*/
    /*const handleToggleButton = (e) => {
        const { value, dataset } = e.target
        const { status } = dataset

        let toHide = true
        let toHideChild = true
        let render = true

        const calendarInstance = calendarRef.current.getInstance();
        if(value === "all") {
            if(status === 'true') {
                // document.getElementById('calendar-' + value).removeAttribute('checked')
                document.getElementById('calendar-' + value).checked = false
                e.target.dataset.status = false
                toHide = true
            }
            else {
                //document.getElementById('calendar-' + value).setAttribute('checked', 'checked')
                document.getElementById('calendar-' + value).checked = true
                e.target.dataset.status = true
                toHide = false
            }

            if(status !== 'true')
                toHideChild = false
            
            calendars.forEach((v) => {
                if(toHide) {
                    document.getElementById('calendar-' + v.id).dataset.status = false
                    // document.getElementById('calendar-' + v.id).removeAttribute('checked')
                    document.getElementById('calendar-' + v.id).checked = false
                    v.status = false
                }
                else {
                    document.getElementById('calendar-' + v.id).dataset.status = true
                    // document.getElementById('calendar-' + v.id).setAttribute('checked', 'checked')
                    document.getElementById('calendar-' + v.id).checked = true
                    v.status = true
                }
    
                calendarInstance.toggleSchedules(v.id, toHideChild, render)
            })
        }
        else {
            if(status === 'true') {
                document.getElementById('calendar-' + value).dataset.status = false
                // document.getElementById('calendar-' + value).removeAttribute('checked')
                document.getElementById('calendar-' + value).checked = false
                toHide = true
            }
            else {
                document.getElementById('calendar-' + value).dataset.status = true
                // document.getElementById('calendar-' + value).setAttribute('checked', 'checked')
                document.getElementById('calendar-' + value).checked = true
                toHide = false
            }

            let allChecked = true
            calendars.forEach((v) => {
                if(document.getElementById('calendar-' + v.id).dataset.status === 'false')
                    allChecked = false
            })

            if(allChecked) {
                document.getElementById('calendar-all').dataset.status = true
                document.getElementById('calendar-all').checked = true
            }
            else {
                document.getElementById('calendar-all').dataset.status = false
                document.getElementById('calendar-all').checked = false

            }

            calendarInstance.toggleSchedules(value, toHide, render)
        }
    }*/

    //DUPLICAR REGISTO
    function duplicateFormation(row) {

        console.log('Registo original: ', row)

        var today_submit = new Date().toJSON()

        let aux_clone_row = []

        aux_clone_row = JSON.parse(JSON.stringify(row))

        /*if(aux_clone_row.info.trainers !== undefined && aux_clone_row.info.trainers.length > 0) {

            aux_clone_row.info.trainers = []

        }*/

        if(aux_clone_row.info.date.modified !== undefined && aux_clone_row.info.date.modified.length > 0) {

            aux_clone_row.info.date.modified = []

        }

        if(aux_clone_row.content[0].candidates !== undefined && aux_clone_row.content[0].candidates.length > 0) {

            aux_clone_row.content[0].candidates = []

        }

        if(aux_clone_row.content[0].trainees !== undefined && aux_clone_row.content[0].trainees.length > 0) {

            aux_clone_row.content[0].trainees = []

        }

        /*if(aux_clone_row.content[0].media.doc !== undefined && aux_clone_row.content[0].media.doc.length > 0) {

            aux_clone_row.content[0].media.doc = []

        }

        if(aux_clone_row.content[0].media.image !== undefined && aux_clone_row.content[0].media.image.length > 0) {

            aux_clone_row.content[0].media.image = []

        }*/

        if(aux_clone_row.content[0].modules !== undefined && aux_clone_row.content[0].modules.length > 0) {

            aux_clone_row.content[0].modules.forEach(v => {

                if(v.trainees !== undefined && v.trainees.length > 0) {

                    v.trainees = []
        
                }

                /*if(v.trainer !== undefined && v.trainer !== null && v.trainer !== '') {

                    v.trainer = { 
                        email: '',
                        id:  '',
                        name: '',
                        notified: false,
                        username: ''
                        
                    }
        
                }*/

                if(v.sessions !== undefined && v.sessions.length > 0){

                    //v.sessions = []
                
                    v.sessions.forEach(v2 => {

                        if(v2.trainees !== undefined && v2.trainees.length > 0) {

                            v2.trainees = []
                
                        }

                        if(v2.uniqid !== undefined && v2.uniqid !== '') {

                            let uid = uniqid()

                            //console.log('novo uid da sessão: ', uid)

                            v2.uniqid = uid
                
                        }

                    })
                }
           })

        }

        aux_clone_row.id = ''
        aux_clone_row.info.date.publication = ''
        aux_clone_row.info.date.begin = ''
        aux_clone_row.info.date.end = ''
        if(aux_clone_row.info.date.registration_begin !== undefined && aux_clone_row.info.date.registration_begin !== '') {
            aux_clone_row.info.date.registration_begin = ''
        }
        if(aux_clone_row.info.date.registration_deadline !== undefined && aux_clone_row.info.date.registration_deadline !== '') {
            aux_clone_row.info.date.registration_deadline = ''
        }
        aux_clone_row.info.date.creation = today_submit
        aux_clone_row.info.status = 'without_emphasis'
        aux_clone_row.info.name = (aux_clone_row.info.name + ' ('+ language[lang].duplicated + ')')
        aux_clone_row.content[0].title = (aux_clone_row.content[0].title + ' ('+ language[lang].duplicated + ')')

        //console.log('Registo duplicado e modificado: ', aux_clone_row)

        Swal.fire({
			title: language[lang].duplicate_title,
			text: language[lang].duplicate_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].duplicate_yes,
			cancelButtonText: language[lang].duplicate_no
		})
        .then((result) => {
            if (result.isConfirmed) {

                //com opções de escolha antes de fazer a duplicação
                Swal.fire({
                    title: language[lang].duplication_options,
                    icon: 'question',
                    html: '<div><label><input type="checkbox" id="imagem" />&nbsp;&nbsp;' + language[lang].duplication_options_checkbox_01 + '</label></div>' +
                        '<div><label><input type="checkbox" id="documentos" />&nbsp;&nbsp;' + language[lang].duplication_options_checkbox_02 + '</label></div>' +
                        '<div><label><input type="checkbox" id="formadores" />&nbsp;&nbsp;' + language[lang].duplication_options_checkbox_03 + '</label></div>' ,
                    preConfirm: () => {
                        var formadores = Swal.getPopup().querySelector('#formadores').checked
                        var documentos = Swal.getPopup().querySelector('#documentos').checked
                        var imagem = Swal.getPopup().querySelector('#imagem').checked
                        console.log("formadores = " + formadores + "\n documentos = " + documentos + "\n imagem = " + imagem)

                        if(!formadores){
                            
                            if(aux_clone_row.info.trainers !== undefined && aux_clone_row.info.trainers.length > 0) {

                                aux_clone_row.info.trainers = []
                            }

                            if(aux_clone_row.content[0].modules !== undefined && aux_clone_row.content[0].modules.length > 0) {

                                aux_clone_row.content[0].modules.forEach(v => {

                                    if(v.evaluations_material !== undefined && v.evaluations_material.length > 0 ){
                                        v.evaluations_material = []
                                    }

                                    if(v.support_material !== undefined && v.support_material.length > 0 ){
                                        v.support_material = []
                                    }
                    
                                    if(v.trainer !== undefined && v.trainer !== null && v.trainer !== '') {
                                        v.trainer = { 
                                            email: '',
                                            id:  '',
                                            name: '',
                                            notified: false,
                                            username: ''
                                        }
                                    }

                                    if(v.sessions !== undefined && v.sessions.length > 0){
                                    
                                        v.sessions.forEach(v2 => {
                    
                                            if(v2.evaluations_material !== undefined && v2.evaluations_material.length > 0) {
                    
                                                v2.evaluations_material = []
                                    
                                            }

                                            if(v2.evaluations_material_links !== undefined && v2.evaluations_material_links.length > 0) {
                    
                                                v2.evaluations_material_links = []
                                    
                                            }

                                            if(v2.support_material !== undefined && v2.support_material.length > 0) {
                    
                                                v2.support_material = []
                                    
                                            }

                                            if(v2.support_material_links !== undefined && v2.support_material_links.length > 0) {
                    
                                                v2.support_material_links = []
                                    
                                            }
                    
                    
                                        })
                                    }
                                })
                            }
                
                        }

                        if(!documentos && aux_clone_row.content[0].media.doc !== undefined && aux_clone_row.content[0].media.doc.length > 0) {

                            aux_clone_row.content[0].media.doc = []
                
                        }

                        if(!imagem && aux_clone_row.content[0].media.image !== undefined && aux_clone_row.content[0].media.image.length > 0) {

                            aux_clone_row.content[0].media.image = []
                
                        }
            
            
                        return {formadores: formadores, documentos: documentos, imagem: imagem}
                    },
                    showCancelButton: true,
                    confirmButtonColor: '#0095e8',
                    cancelButtonColor: '#d9214e',
                    confirmButtonText: language[lang].duplicate_confirm,
                    cancelButtonText: language[lang].duplicate_cancel
                })
                .then((result) => {
                    if (result.isConfirmed) {

                        //console.log('Formadores duplicados: ', result.value.formadores)
                        //console.log('Documentos duplicados: ', result.value.documentos)
                        //console.log('Imagem duplicada: ', result.value.imagem)

                        console.log('Registo duplicado e modificado após opções:', aux_clone_row)

                        reqPOST((`${Hosts.SIMCore_API}/formation/course`), aux_clone_row)
                            .then(() => { 

                                setRefresh(refresh + 1)

                                //window.location.reload()

                                //props.history.push(endpoints.list) 
                            })
                            .catch(() => Swal.fire(language[lang].duplicate_error, '', 'info'))
                            }
                })
            }
        })

    }

    const columns = [
        {
            name: language[lang].name,
            selector: 'info.name',
            cell: row => <div>
                {
                    row.content[0].title
                }

            </div>,
            width: '50%',
            minWidth: '30% !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].start,
            selector: 'info.date.begin',
            cell: row => {
                let date = new Date(row.info.date.begin); 

                if(row.info.date.begin !== '') {
                
                    return date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear()
               
                } else {

                    return ''

                }
            },
            width: '10%',
            minWidth: '110px !important',
            sortable: true,
            center: true,
        },
        {
            name: language[lang].end,
            selector: 'info.date.end',
            cell: row => {
                let date = new Date(row.info.date.end);

                if(row.info.date.end !== '') {
                
                    return date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear()
               
                } else {

                    return ''

                }
            },
            width: '10%',
            minWidth: '110px !important',
            sortable: true,
            center: true,
        },
        
        {
            name: '',
            right: true,
            export: false,
            print: false,
            width: '20%',
            minWidth: '200px !important',
            cell: row =>
                <span>
                    {
                        //passados 15 dias da conclusão do curso o formando já não pode aceder à view da formação
                        (getTokenInfo().profile === 'trainee_user') && (((new Date().getTime() - new Date(row.info.date.end).getTime()) / (1000 * 3600 * 24)).toFixed(0) <= 15) ?
                            <Link className="button button-update button-view" to={{ pathname: '/formation_content_view', state: { item: row, operation: 'edit' } }} >
                                <i className="bi bi-eye"></i>
                                <span className="tooltiptext">{language[lang].view}</span>
                            </Link>
                        :
                            null
                    }
                    {
                        (getTokenInfo().profile === 'Gestor de formações' || getTokenInfo().profile === 'Administrador') ?
                            <Link className="button button-update" to={{ pathname: '/formation_content_regist', state: { item: row, operation: 'edit', go_back_operation : 'main_view' } }} >
                                <i className="bi bi-pencil"></i>
                                <span className="tooltiptext">{language[lang].edit}</span>
                            </Link>
                        :
                            null
                    }

                    {
                        (getTokenInfo().profile === 'Gestor de formações' || getTokenInfo().profile === 'Administrador') ?
                            <Link className="button button-gest" to={{ pathname: '/formation_content_gest', state: { item: row, operation: 'edit', go_back_operation : 'main_view' } }} >
                                <i className="bi bi-gear"></i>
                                <span className="tooltiptext">{language[lang].gest}</span>
                            </Link>
                        :
                        null
                    }
                    {
                        (getTokenInfo().profile === 'Gestor de formações' || getTokenInfo().profile === 'Administrador') ?

                            <button className={"button button-duplicate"} onClick={() => duplicateFormation(row)} >
                                <i className="bi bi-files"></i>
                                <span className="tooltiptext">{language[lang].duplicate_title}</span>
                            </button>
                            
                        :
                            null 
                    }
                </span>
        },
    ];

    const columns_trainer = [
        {
            name: language[lang].name,
            selector: 'info.name',
            cell: row => <div>
                    <strong>{row.name_formation +  ': '}</strong>
                    {row.name}
            </div>,
            width: '50%',
            minWidth: '30% !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].sessions_number,
            selector: 'sessions_number',
            width: '15%',
            sortable: false,
            left: true,
        },
        {
            name: language[lang].duration,
            selector: 'duration',
            width: '15%',
            sortable: false,
            left: true,
        }, 
        
        {
            name: '',
            right: true,
            export: false,
            print: false,
            width: '20%',
            minWidth: '200px !important',
            cell: row =>
                <span>
                    {
                        //passados 15 dias da conclusão do curso o formando já não pode aceder à view da formação
                        (getTokenInfo().profile === 'trainee_user') && (((new Date().getTime() - new Date(row.info.date.end).getTime()) / (1000 * 3600 * 24)).toFixed(0) <= 15) ?
                            <Link className="button button-update button-view" to={{ pathname: '/formation_content_view', state: { item: row, operation: 'edit' } }} >
                                <i className="bi bi-eye"></i>
                                <span className="tooltiptext">{language[lang].view}</span>
                            </Link>
                        :
                            null
                    }
                    {
                        getTokenInfo().profile === 'trainer_user' ?
                            <Link className="button button-update" to={{ pathname: '/formation_module_regist', state: { item: row, operation: 'edit', go_back_operation : 'main_view' } }} >
                                <i className="bi bi-pencil"></i>
                                <span className="tooltiptext">{language[lang].edit}</span>
                            </Link>
                        :
                            null
                    }

                    {
                        getTokenInfo().profile === 'trainer_user' ?
                            <Link className="button button-gest" to={{ pathname: '/formation_module_gest', state: { item: row, operation: 'edit', go_back_operation : 'main_view' } }} >
                                <i className="bi bi-gear"></i>
                                <span className="tooltiptext">{language[lang].gest}</span>
                            </Link>
                        :
                        null
                    }
                </span>
        },
    ];

    const columns_trainee_cursos_d = [
        {
            name: language[lang].name,
            selector: 'info.name',
            cell: row => <div>
                {
                    row.content[0].title
                }

            </div>,
            width: '50%',
            minWidth: '30% !important',
            sortable: true,
            left: true,
        },
        /*
        {
            name: language[lang].table_date_begin,
            selector: 'info.date.begin',
            cell: row => {
                let date = new Date(row.info.date.begin); 

                if(row.info.date.begin !== '') {
                
                    return date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear()
               
                } else {

                    return ''

                }
            },
            width: '10%',
            minWidth: '110px !important',
            sortable: true,
            center: true,
        },*/
        /*{
            name: language[lang].end,
            selector: 'info.date.end',
            cell: row => {
                let date = new Date(row.info.date.end);

                if(row.info.date.end !== '') {
                
                    return date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear()
               
                } else {

                    return ''

                }
            },
            width: '10%',
            minWidth: '110px !important',
            sortable: true,
            center: true,
        },*/
        {
            name: language[lang].table_state,
            selector: 'title',
            cell: row => {
                 //console.log('ROWWWWW', row)
                 //console.log('P', percentagem)

                let p = percentagem[row.id]
                
                return (
                    <> 
                        {Math.trunc(p)}%

                        <br />

                        <ProgressBar percentagem={p}/>  
                    </>               
                )
            },
            width: '30%',
            minWidth: '82px !important',
            sortable: false,
            center: true,
        },
        
        {
            name: '',
            right: true,
            export: false,
            print: false,
            width: '20%',
            minWidth: '200px !important',
            cell: row =>
                <span>
                    {
                        //passados 15 dias da conclusão do curso o formando já não pode aceder à view da formação
                        //(getTokenInfo().profile === 'trainee_user') && (((new Date().getTime() - new Date(row.info.date.end).getTime()) / (1000 * 3600 * 24)).toFixed(0) <= 15) ?
                            <Link className="button button-update button-view" to={{ pathname: '/formation_content_view', state: { item: row, operation: 'edit', go_back_operation : 'main_view', } }} >
                                <i className="bi bi-eye"></i>
                                <span className="tooltiptext">{language[lang].view}</span>
                            </Link>
                        //:
                            //null
                    }
                </span>
        },
    ];

    const columns_trainee_cursos_c = [
        {
            name: language[lang].name,
            selector: 'info.name',
            cell: row => <div>
                {
                    row.content[0].title
                }

            </div>,
            width: '50%',
            minWidth: '30% !important',
            sortable: true,
            left: true,
        },
        /*
        {
            name: language[lang].table_date_begin,
            selector: 'info.date.begin',
            cell: row => {
                let date = new Date(row.info.date.begin); 

                if(row.info.date.begin !== '') {
                
                    return date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear()
               
                } else {

                    return ''

                }
            },
            width: '10%',
            minWidth: '110px !important',
            sortable: true,
            center: true,
        },*/
        {
            name: language[lang].end,
            selector: 'info.date.end',
            cell: row => {
                let date = new Date(row.info.date.end);

                if(row.info.date.end !== '') {
                
                    return date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear()
               
                } else {

                    return ''

                }
            },
            width: '10%',
            minWidth: '110px !important',
            sortable: true,
            center: true,
        },
        /*{
            name: language[lang].table_state,
            selector: 'title',
            cell: row => {
                 //console.log('ROWWWWW', row)
                 //console.log('P', percentagem)

                let p = percentagem[row.id]
                
                return (
                    <> 
                        {Math.trunc(p)}%

                        <br />

                        <ProgressBar percentagem={p}/>  
                    </>               
                )
            },
            width: '30%',
            minWidth: '82px !important',
            sortable: false,
            center: true,
        },
        */

        {
            name: language[lang].certificate,
            selector: 'certificate',
            cell: row => {
                 //console.log('ROWWWWW', row)

                 let auxCertificate = []
                 if(row.content[0].trainees[0].files !== undefined && row.content[0].trainees[0].files.length > 0) {

                    row.content[0].trainees[0].files.forEach(v => {

                        auxCertificate.push(v)

                    })

                 }

                 if(auxCertificate.length > 0){
                    return (
                        <div>
                            <a href={auxCertificate[0].link} alt={auxCertificate[0].name} title={auxCertificate[0].name} target='_blank' rel="noreferrer">
                                <i className="bi bi-file-pdf me-2"></i>
                                {/*auxCertificate[0].name*/}
                                {language[lang].certificate_view}
                            </a>
                        </div>
                    )
                 }
            },
            width: '20%',
            minWidth: '82px !important',
            sortable: false,
            center: true,
        },
        
        {
            name: '',
            right: true,
            export: false,
            print: false,
            width: '20%',
            minWidth: '200px !important',
            cell: row =>
                <span>
                    {
                        //passados 15 dias da conclusão do curso o formando já não pode aceder à view da formação
                        (getTokenInfo().profile === 'trainee_user') && (((new Date().getTime() - new Date(row.info.date.end).getTime()) / (1000 * 3600 * 24)).toFixed(0) <= 15) ?
                            <Link className="button button-update button-view" to={{ pathname: '/formation_content_view', state: { item: row, operation: 'edit', go_back_operation : 'main_view' } }} >
                                <i className="bi bi-eye"></i>
                                <span className="tooltiptext">{language[lang].view}</span>
                            </Link>
                        :
                            null
                    }
                </span>
        },
    ];


    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    return (isloading ?
            null
        :
            <main>
                <div className={`dash-cards-2 header`}>
                    <h2 className="dash-title">{language[lang].dashboard}</h2>
                    <p>{language[lang].dashboard}</p>
                </div>

                <div className='container'>
                    <div className={`dash-cards-2 highlights ps-0`}>
                        <div className="card-single">
                            <div className="card-body">
                                <div>
                                    <h5>Titulo 1</h5>
                                    <h4>12</h4>
                                </div>
                            </div>
                        </div>
                        <div className="card-single">
                            <div className="card-body">
                                <div>
                                    <h5>Titulo 2</h5>
                                    <h4>22</h4>
                                </div>
                            </div>
                        </div>
                        <div className="card-single">
                            <div className="card-body">
                                <div>
                                    <h5>Titulo 3</h5>
                                    <h4>1</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                    true === false ? 
                        <div className='row'>
                            <div className='col-12 col-sm-8'>
                                {
                                (getTokenInfo().profile === 'Gestor de formações'|| getTokenInfo().profile === 'Administrador') ?
                                    <div className={`dash-cards-2 highlights ps-0`}>
                                        {/*<div className='clearfix'></div>*/}
                                        <div className="card-single">
                                            <div className="card-body">
                                                <div>
                                                    <h5>{language[lang].dash_formandos_registados}</h5>
                                                    <h4>{n_trainees}</h4>
                                                    <Link 
                                                        className="btn btn-link p-0"
                                                        to={{ 
                                                            pathname: '/trainee_list',
                                                        }} >
                                                            <i className="bi bi-people fs-4 me-2"></i>
                                                            <span>{language[lang].list_view}</span>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-single">
                                            <div className="card-body">
                                                <div>
                                                    <h5>{language[lang].dash_formadores_registados}</h5>
                                                    <h4>{n_trainers}</h4>
                                                    <Link 
                                                        className="btn btn-link p-0"
                                                        to={{ 
                                                            pathname: '/trainer_list',
                                                        }} >
                                                            <i className="bi bi-people fs-4 me-2"></i>
                                                            <span>{language[lang].list_view}</span>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-single">
                                            <div className="card-body">
                                                <div>
                                                    <h5>{language[lang].dash_cursos}</h5>
                                                    <h4>{n_cursos}</h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-single">
                                            <div className="card-body">
                                                <div>
                                                    <h5>{language[lang].courses_available}</h5>
                                                    <h4>{n_cursos_para_incricao}</h4>
                                                    <Link 
                                                        className="btn btn-link p-0"
                                                        to={{ 
                                                            pathname: '/courses_list',
                                                        }} >
                                                            <i className="bi bi-book fs-4 me-2"></i>
                                                            <span>{language[lang].list_view}</span>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-single">
                                            <div className="card-body">
                                                <div>
                                                    <h5>{language[lang].dash_cursos_desenvolvimento}</h5>
                                                    <h4>{a_cursos_d.length}</h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-single">
                                            <div className="card-body">
                                                <div>
                                                    <h5>{language[lang].dash_cursos_terminados}</h5>
                                                    <h4>{a_cursos_c.length}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                : 
                                    null
                                }

                                {
                                (getTokenInfo().profile === 'Webuser') ?
                                    <div className={`dash-cards-2 highlights ps-0`}>
                                        <div className="card-single">
                                            <div className="card-body">
                                                <div>
                                                    <h5>{language[lang].dash_testimony}</h5>
                                                    <h4>{n_testimony}</h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={"card-single" + ((getTokenInfo().profile === 'trainee_user' || getTokenInfo().profile === 'trainer_user') ? '' : ' d-none')}>
                                            <div className="card-body">
                                                <div>
                                                    <h5>{getTokenInfo().profile === 'trainer_user' ? language[lang].dash_atribuido : language[lang].dash_inscricoes}</h5>
                                                    <h4>{n_inscricoes}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                : 
                                    null
                                }

                                {
                                ('trainee_user' === getTokenInfo().profile || 'trainer_user' === getTokenInfo().profile) ?
                                    <div className='dash-cards body ps-0'>
                                        <div className="div-table">
                                            {
                                            a_cursos_d !== undefined && a_cursos_d.length > 0 ?
                                                <div className="table-body">
                                                    <div className="flex-1">
                                                        <h3 className="fw-bolder m-0">{language[lang].dash_cursos_desenvolvimento}</h3>
                                                    </div>
                                                    
                                                    <div>

                                                        {
                                                            ('trainee_user' === getTokenInfo().profile) ?
                                                                <DataTable
                                                                    columns={columns_trainee_cursos_d}
                                                                    data={a_cursos_d}
                                                                    noDataComponent={language[lang].table_empty}
                                                                    noHeader
                                                                    pagination
                                                                    exportHeaders
                                                                    paginationComponentOptions={defaultComponentOptions}
                                                                    paginationPerPage={25}
                                                                    paginationRowsPerPageOptions={[25, 50, 100]}
                                                                />
                                                            :

                                                                <DataTable
                                                                    columns={columns_trainer}
                                                                    data={a_cursos_d}
                                                                    noDataComponent={language[lang].table_empty}
                                                                    noHeader
                                                                    pagination
                                                                    exportHeaders
                                                                    paginationComponentOptions={defaultComponentOptions}
                                                                    paginationPerPage={25}
                                                                    paginationRowsPerPageOptions={[25, 50, 100]}
                                                                />
                                                        }
                                                    </div>
                                                </div>
                                            :
                                                null
                                            }
                                            {
                                            a_cursos_c !== undefined && a_cursos_c.length > 0 ?
                                                <div className="table-body mt-3">
                                                    <div className="flex-1">
                                                        <h3 className="fw-bolder m-0">{language[lang].dash_cursos_terminados}</h3>
                                                    </div>
                                                    {
                                                        ('trainee_user' === getTokenInfo().profile && a_cursos_c.length > 0) ?
                                                            <div className="mb-3 position-relative">
                                                                {/*<label className="col-form-label fs-6 fw-bold">{language[lang].notice}&#58;</label>
                                                                <p>{language[lang].notice_message}</p>*/}
                                                                <button type='button' className='info'>
                                                                    <i className="bi bi-info-square text-info fs-4" /*title={language[lang].notice_message}*/></i>
                                                                    <span className="tooltiptext text-start">{language[lang].notice_message}</span>
                                                                </button>
                                                                
                                                            </div>
                                                        : null
                                                    }
                                                    <div>

                                                        {
                                                            ('trainee_user' === getTokenInfo().profile) ?
                                                                <DataTable
                                                                    columns={columns_trainee_cursos_c}
                                                                    data={a_cursos_c}
                                                                    noDataComponent={language[lang].table_empty}
                                                                    noHeader
                                                                    pagination
                                                                    exportHeaders
                                                                    paginationComponentOptions={defaultComponentOptions}
                                                                    paginationPerPage={25}
                                                                    paginationRowsPerPageOptions={[25, 50, 100]}
                                                                />
                                                            :
                                                                <DataTable
                                                                    columns={columns_trainer}
                                                                    data={a_cursos_c}
                                                                    noDataComponent={language[lang].table_empty}
                                                                    noHeader
                                                                    pagination
                                                                    exportHeaders
                                                                    paginationComponentOptions={defaultComponentOptions}
                                                                    paginationPerPage={25}
                                                                    paginationRowsPerPageOptions={[25, 50, 100]}
                                                            />
                                                        }

                                                    </div>
                                                </div>
                                            :
                                                null
                                            }
                                        </div>
                                    </div>
                                : 
                                    null 
                                }
                            </div>
                            <div className='col-12 col-sm-4'>
                                <div className='dash-cards-2 dash-calendar mt-5'>
                                    {
                                    //schedueles.length > 0 ?
                                        <>
                                            {/*console.log('schedueles', schedueles)*/}

                                            <div className="flex-1 text-center">
                                                <h3 className="fw-bolder m-0">{calendarTitle}</h3>
                                            </div>

                                            <Calendar
                                                ref={calendarRef}
                                                height="400px"
                                                calendars={calendars}
                                                disableDblClick={true}
                                                disableClick={false}
                                                isReadOnly={true}
                                                month={{
                                                    startDayOfWeek: 0,
                                                    daynames: language[lang].calendar_daynames
                                                }}
                                                schedules={schedueles}
                                                scheduleView
                                                taskView={false}
                                                template={myTemplate}
                                                theme={myTheme}
                                                timezones={[
                                                    {
                                                        timezoneName: 'Europe/Lisbon',
                                                        displayLabel: 'UTC+00',
                                                        tooltip: 'Lisbon'
                                                    }
                                                ]}
                                                useDetailPopup
                                                useCreationPopup={false}
                                                view={selectedView}
                                                week={{
                                                    hourStart: 0,
                                                    hourEnd: 24,
                                                    showTimezoneCollapseButton: true,
                                                    timezonesCollapsed: true,
                                                    daynames: language[lang].calendar_daynames
                                                }}
                                            />
                                        </>
                                    //:
                                        //null
                                    }
                                </div>
                            </div>
                            {
                            (getTokenInfo().profile === 'Gestor de formações'|| getTokenInfo().profile === 'Administrador') ?
                                <div className='col-12'>

                                    <div className='dash-cards body ps-0'>
                                        <div className="div-table">
                                            {
                                                a_cursos_d !== undefined && a_cursos_d.length > 0 ?
                                                    <div className="table-body">
                                                        <div className="flex-1">
                                                            <h3 className="fw-bolder m-0">{language[lang].dash_cursos_desenvolvimento}</h3>
                                                        </div>
                                                        
                                                        <div>
                                                            <DataTable
                                                                columns={columns}
                                                                data={a_cursos_d}
                                                                noDataComponent={language[lang].table_empty}
                                                                noHeader
                                                                pagination
                                                                exportHeaders
                                                                paginationComponentOptions={defaultComponentOptions}
                                                                paginationPerPage={25}
                                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                                            />
                                                        </div>
                                                    </div>
                                                :
                                                    null
                                            }
                                            {
                                                a_cursos_c !== undefined && a_cursos_c.length > 0 ?
                                                    <div className="table-body mt-3">
                                                        <div className="flex-1">
                                                            <h3 className="fw-bolder m-0">{language[lang].dash_cursos_terminados}</h3>
                                                        </div>
                                                        <div>
                                                            <DataTable
                                                                columns={columns}
                                                                data={a_cursos_c}
                                                                noDataComponent={language[lang].table_empty}
                                                                noHeader
                                                                pagination
                                                                exportHeaders
                                                                paginationComponentOptions={defaultComponentOptions}
                                                                paginationPerPage={25}
                                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                                            />
                                                        </div>
                                                    </div>
                                                :
                                                    null
                                            }
                                        </div>
                                    </div>
                                </div>
                            : 
                                null 
                            }
                        </div>
                    :
                        null
                    }
                </div>
            </main>
    )
}
